// Extracted from AIWorkoutGenerator.js during Phase 4 refactor (sprint 2026-06-20).
import React, { useState, useEffect } from 'react';
import { api } from '../../context/AppContext';
import useExerciseHistory from '../../hooks/useExerciseHistory';
import { motion } from 'framer-motion';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import {
  Zap, Loader2, Play, Dumbbell, Clock, Repeat, Timer, ChevronDown, ChevronUp,
  Battery, BatteryLow, BatteryFull, Star, ThumbsUp, Send, Info,
  AlertTriangle, Shield, Save, BookmarkCheck, ExternalLink, History, RotateCcw, Trophy, Crosshair,
  CalendarDays, Layers, Target, Wrench, HeartPulse, BookOpen, Flame, TrendingUp
} from 'lucide-react';
import { toast } from 'sonner';

export default function FeedbackSection({ planId, language, onSubmitted }) {
  const { t } = useLanguage();
  const [rating, setRating] = useState(null);
  const [comments, setComments] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const submit = async () => {
    if (!rating) return;
    setSubmitting(true);
    try {
      await api.post('/workouts/feedback', {
        plan_id: planId,
        intensity_rating: rating,
        comments: comments || undefined,
      });
      toast.success(t('ai_workout_gen.retroaction_enregistree_l_ia_s_adaptera', 'Retroaction enregistrée! L\\\'IA s\\\'adaptera.'));
      onSubmitted?.();
    } catch {
      toast.error('Erreur');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Card className="bg-card border-primary/30 border-2" data-testid="workout-feedback">
      <CardContent className="p-4 space-y-3">
        <p className="text-sm font-heading uppercase tracking-wider text-primary">
          {t('ai_workout_gen.comment_etait_l_intensite', 'Comment etait l\\\'intensite?')}
        </p>
        <div className="grid grid-cols-5 gap-2">
          {INTENSITY_LABELS.map(il => (
            <button
              key={il.value}
              onClick={() => setRating(il.value)}
              data-testid={`feedback-${il.value}`}
              className={`p-2 rounded-lg border text-center transition-all ${
                rating === il.value ? il.color + ' border-2' : 'bg-secondary/30 border-border text-muted-foreground'
              }`}
            >
              <span className="text-xl block">{il.icon}</span>
              <span className="text-[9px] block mt-1">{il.label_fr}</span>
            </button>
          ))}
        </div>
        <Textarea
          value={comments}
          onChange={(e) => setComments(e.target.value)}
          placeholder={t('ai_workout_gen.commentaires_optionnel', 'Commentaires (optionnel)...')}
          className="min-h-[60px] text-sm bg-secondary border-input resize-none"
          data-testid="feedback-comments"
        />
        <Button
          onClick={submit}
          disabled={!rating || submitting}
          className="w-full bg-primary text-primary-foreground font-heading uppercase"
          data-testid="submit-feedback-btn"
        >
          {submitting ? <Loader2 className="w-4 h-4 animate-spin mr-1.5" /> : <Send className="w-4 h-4 mr-1.5" />}
          {t('ai_workout_gen.envoyer', 'Envoyer')}
        </Button>
      </CardContent>
    </Card>
  );
}

// ─────────────────────────────────────────────────────────────────────
// QuickDirectiveChips — Iter. 406.fr.27 (Yuri suggestion accepted)
// Chips 1-tap pour les coachs pressés : tap = ajoute la phrase dans la
// textarea `customPreferences`, re-tap = la retire. Détection "déjà
// présente" via includes() insensible à la casse.
// ─────────────────────────────────────────────────────────────────────
